export const SEARCH_CATEGORY = 'SEARCH_CATEGORY'
export const RESET_CATEGORY = 'RESET_CATEGORY'
export const SHOW_LOADING = 'SHOW_LOADING'
export const HIDE_LOADING = 'HIDE_LOADING'



export const callCategories = (categories: any) => async(dispatch : any) => {
  dispatch({
    type: SEARCH_CATEGORY,
    payload: categories
  })
}

export function resetCategory(name: string) {
  return (dispatch: any) => {
    dispatch(reset(name))
  }
}

const reset = (name: string) => ({
  type: RESET_CATEGORY,
  payload: name
})
